import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { App } from 'antd';
import { txt } from 'libs/i18n';
import FormModal from 'components/FormModal';
import { useSession } from 'components/Authenticated';
import { fetchSpeaker, fetchSpeakerHistory, updateSpeaker } from 'api/speaker-api-v2';
import { buildRestoreBody, hasVisibleChanges } from './SpeakerHistoryList/history-utils';
import SpeakerHistoryList from './SpeakerHistoryList';
import VersionDetailPanel from './VersionDetailPanel';
import styles from './style.module.less';
const SpeakerDetailModal = ({ uniqueId, onClose }) => {
    var _a;
    const { session } = useSession();
    const { message } = App.useApp();
    const [speakerData, setSpeakerData] = useState(null);
    const [speakerHistory, setSpeakerHistory] = useState(null);
    const [selectedEntry, setSelectedEntry] = useState(null);
    const fetchData = () => {
        void fetchSpeaker(session.connection, uniqueId).then((result) => {
            if (result.isSuccess()) {
                setSpeakerData(result.get());
            }
        });
        void fetchSpeakerHistory(session.connection, uniqueId).then((result) => {
            if (result.isSuccess()) {
                setSpeakerHistory(result.get());
            }
        });
    };
    useEffect(() => {
        setSpeakerData(null);
        setSpeakerHistory(null);
        setSelectedEntry(null);
        fetchData();
    }, [uniqueId]);
    useEffect(() => {
        if (speakerHistory !== null && selectedEntry === null) {
            const visibleEntries = speakerHistory.list.slice().reverse().filter(hasVisibleChanges);
            if (visibleEntries.length > 0) {
                setSelectedEntry(visibleEntries[0]);
            }
        }
    }, [speakerHistory]);
    const handleRestoreVersion = async (entry) => {
        const body = buildRestoreBody(entry.dataSnapshot, speakerData === null || speakerData === void 0 ? void 0 : speakerData.concurrencyToken);
        const result = await updateSpeaker(session.connection, uniqueId, body);
        if (!result.isSuccess()) {
            void message.error(txt('unexpectedError'));
            throw new Error('restore failed');
        }
        void message.success(txt('speakerVersionRestored'));
        fetchData();
    };
    const visibleEntries = (_a = speakerHistory === null || speakerHistory === void 0 ? void 0 : speakerHistory.list.slice().reverse().filter(hasVisibleChanges)) !== null && _a !== void 0 ? _a : [];
    const selectedEntryIndex = selectedEntry !== null
        ? visibleEntries.findIndex((e) => e.timestamp === selectedEntry.timestamp)
        : -1;
    const isLatestVersionSelected = selectedEntryIndex === 0;
    return (_jsx(FormModal, { title: txt('versionsHistory'), open: true, onCancel: onClose, onOk: onClose, cancelButtonProps: { style: { display: 'none' } }, width: 1100, style: { top: 32 }, className: styles.modal, children: _jsxs("div", { className: styles.twoPanel, children: [_jsx("div", { className: styles.historyPanel, children: _jsx(SpeakerHistoryList, { history: speakerHistory, selectedEntry: selectedEntry, onSelectEntry: setSelectedEntry }) }), _jsx("div", { className: styles.detailPanel, children: _jsx(VersionDetailPanel, { entry: selectedEntry, isLatestVersion: isLatestVersionSelected, onRestoreVersion: handleRestoreVersion }) })] }) }));
};
export default SpeakerDetailModal;
